import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetCustomer = async (customerID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Customer/getCustomer/${customerID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else if(response.ok && !data.isError ){
        return data.result;
      } 
      else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const GetCustomerWithPagination = async (
  CustomerID,
  PageSize,
  PageNumber,
  KeyWord,
  CustomerName,
  CompanyName,
  CustomerType,
  PhoneNumber,
  Email,
  Address,
  BillingAddress,
  Status,
  navigate
) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        CustomerID, PageSize, PageNumber,
        KeyWord, CustomerName, CompanyName,
        CustomerType, PhoneNumber, Email,
        Address, BillingAddress, Status
      }).toString();
      const response = await fetch(`${dev_baseUrl}/Customer/get?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },        
      });
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else{
        const items = Array.isArray(data?.result)
          ? data.result
          : Array.isArray(data?.result?.items)
            ? data.result.items
            : [];
        const total =
          data?.totalCount ??
          data?.result?.totalCount ??
          data?.result?.total ??
          data?.result?.count ??
          items?.[0]?.totalCount ??
          items.length;

        return { items, total };
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { items: [], total: 0 };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.', items: [], total: 0 };
  }
};

